export default __webpack_public_path__ + "static/media/fishes-right.702f9077.svg";